module.exports = __webpack_public_path__ + "static/media/delete-data.41778685.png";